// (function () {
//   'use strict';

//   const STORAGE_KEY = 'shopify_wishlist';

//   function getWishlist() {
//     try {
//       return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//     } catch (error) {
//       return [];
//     }
//   }

//   function saveWishlist(wishlist) {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
//   }

//   function isWishlisted(handle) {
//     return getWishlist().includes(handle);
//   }

//   function updateWishlistButtons() {
//     const wishlist = getWishlist();

//     document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
//       const handle = button.dataset.productHandle;

//       if (!handle) return;

//       const active = wishlist.includes(handle);

//       button.classList.toggle('is-wishlisted', active);
//       button.setAttribute('aria-pressed', active ? 'true' : 'false');

//       const label = button.querySelector('[data-wishlist-label]');

//       if (label) {
//         label.textContent = active
//           ? 'Remove from wishlist'
//           : 'Add to wishlist';
//       }

//       button.setAttribute(
//         'aria-label',
//         active
//           ? 'Remove from wishlist'
//           : 'Add to wishlist'
//       );
//     });

//     updateWishlistCount();
//   }

//   function updateWishlistCount() {
//     const count = getWishlist().length;

//     document.querySelectorAll('[data-wishlist-count]').forEach((element) => {
//       element.textContent = count;

//       element.classList.toggle('hidden', count === 0);
//     });
//   }

//   function addToWishlist(handle) {
//     const wishlist = getWishlist();

//     if (!wishlist.includes(handle)) {
//       wishlist.push(handle);
//       saveWishlist(wishlist);
//     }

//     updateWishlistButtons();

//     document.dispatchEvent(
//       new CustomEvent('wishlist:updated', {
//         detail: {
//           wishlist: wishlist
//         }
//       })
//     );
//   }

//   function removeFromWishlist(handle) {
//     let wishlist = getWishlist();

//     wishlist = wishlist.filter((item) => item !== handle);

//     saveWishlist(wishlist);

//     updateWishlistButtons();

//     document.dispatchEvent(
//       new CustomEvent('wishlist:updated', {
//         detail: {
//           wishlist: wishlist
//         }
//       })
//     );
//   }

//   function toggleWishlist(handle) {
//     if (isWishlisted(handle)) {
//       removeFromWishlist(handle);
//     } else {
//       addToWishlist(handle);
//     }
//   }

//   document.addEventListener('click', function (event) {
//     const button = event.target.closest('[data-wishlist-button]');

//     if (!button) return;

//     event.preventDefault();
//     event.stopPropagation();

//     const handle = button.dataset.productHandle;

//     if (!handle) return;

//     toggleWishlist(handle);
//   });

//   /*
//    * Make functions available globally.
//    * Useful for the wishlist page.
//    */
//   window.ShopifyWishlist = {
//     get: getWishlist,
//     add: addToWishlist,
//     remove: removeFromWishlist,
//     toggle: toggleWishlist,
//     has: isWishlisted,
//     updateButtons: updateWishlistButtons
//   };

//   /*
//    * Initialize
//    */
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', updateWishlistButtons);
//   } else {
//     updateWishlistButtons();
//   }

// })();

(function () {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';

  function getWishlist() {
    try {
      const wishlist = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      if (!Array.isArray(wishlist)) {
        return [];
      }

      return wishlist;

    } catch (error) {
      return [];
    }
  }
  function saveWishlist(wishlist) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(wishlist)
    );
  }

  function isWishlisted(sku) {

    if (!sku) {
      return false;
    }

    return getWishlist().some(function (item) {
      return item.sku === sku;
    });
  }
  function updateWishlistButtons() {

    const wishlist = getWishlist();

    document
      .querySelectorAll('[data-wishlist-button]')
      .forEach(function (button) {

        const sku = button.dataset.productSku;

        if (!sku) {
          return;
        }

        const active = wishlist.some(function (item) {
          return item.sku === sku;
        });
        button.classList.toggle(
          'is-wishlisted',
          active
        );
        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );
        const label = button.querySelector(
          '[data-wishlist-label]'
        );

        if (label) {

          label.textContent = active
            ? 'Remove from wishlist'
            : 'Add to wishlist';
        }
        button.setAttribute(
          'aria-label',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );
      });
    updateWishlistCount();
  }

  function updateWishlistCount() {

    const count = getWishlist().length;

    document
      .querySelectorAll('[data-wishlist-count]')
      .forEach(function (element) {

        element.textContent = count;

        element.classList.toggle(
          'hidden',
          count === 0
        );

      });
  }

  function addToWishlist(sku, handle) {
    if (!sku || !handle) {
      return;
    }
    const wishlist = getWishlist();

    const alreadyExists = wishlist.some(function (item) {
      return item.sku === sku;
    });

    if (!alreadyExists) {
      wishlist.push({
        sku: sku,
        handle: handle
      });
      saveWishlist(wishlist);
    }
    updateWishlistButtons();
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: wishlist
        }
      })
    );
  }

  function removeFromWishlist(sku) {
    if (!sku) {
      return;
    }
    let wishlist = getWishlist();
    wishlist = wishlist.filter(function (item) {
      return item.sku !== sku;
    });
    saveWishlist(wishlist);
    updateWishlistButtons();
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: wishlist
        }
      })
    );
  }

  function toggleWishlist(sku, handle) {
    if (isWishlisted(sku)) {
      removeFromWishlist(sku);
    } else {
      addToWishlist(sku, handle);
    }
  }
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '[data-wishlist-button]'
      );
      if (!button) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const sku = button.dataset.productSku;
      const handle = button.dataset.productHandle;
      if (!sku || !handle) {
        return;
      }
      toggleWishlist(sku, handle);
    }
  );

  window.ShopifyWishlist = {
    get: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    has: isWishlisted,
    updateButtons: updateWishlistButtons
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateWishlistButtons
    );
  } else {
    updateWishlistButtons();
  }
})();